import { colors } from "@/plugins/vuetify"

export default [
  { text: "קרב", value: "battle", color: colors.battle },
  { text: "נאום", value: "speech", color: colors.speech },
  { text: "מפגש", value: "meeting", color: colors.meeting },
  { text: "כללי", value: "generic", color: colors.generic },
]
